export interface TabItem {
	name: string,
	localizedName: string,
	canRead: boolean,
	canWrite: boolean,
	canCreate: boolean
}

export enum TabType {
	GAMES = 'Games',
	CHALLENGES = 'Challenges',
	AWARDS = 'Awards',
	BUDGET = 'Budget'
}